import React, { useState } from 'react';
import { Grid, Box, Typography, RadioGroup } from '@mui/material';

import CustomModal from '../../../../common/Modals/CustomModal/CustomModal';
import ModalHeader from '../../../../common/Modals/CustomModal/ModalHeader';
import { fonts, themes } from '../../../../common/themes/themes';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import moment from 'moment';
import {
  baseDateFormatting,
  defaultDateFormatting,
} from '../../../../common/helper';
import DropAndSelect from '../../../../common/components/DropAndSelect/DropAndSelect';
import ModalFooter from '../../../../common/Modals/CustomModal/ModalFooter';
import Compdirection from '../../../../common/themes/CompDirection';
import { DatePickerInput } from '../../../../components';
import CustomTextField from '../../../../common/components/CustomTextField/CustomTextField';
import { leavesService } from '../../../../api/services/leavesService';
import { useAppSelector } from '../../../../infra/hooks';
import toast from 'react-hot-toast';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackGetData: (data: any) => void;
  leaveEligibility: any;
  trans?: any;
  i18n?: any;
  leaveEnhanceEligibilities?: any;
  disable?: any;
  leaveHistoryViewData?: any;
}

const LeaveRejoinform = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  trans,
  i18n,
  leaveEnhanceEligibilities,
  disable,
  leaveHistoryViewData,
}: ModalProps) => {
  const [rejoinDate, setRejoinDate] = useState<any>(null);
  const [reason, setReason] = useState<string>('');
  const selector = useAppSelector((state) => state);
  const handleSubmit = async () => {
    if (rejoinDate == null) {
      toast.error(trans('Please select rejoining date'));
      return;
    }
    const empID: any = selector.authSlice.emp_id;
    const formData = new FormData();
    formData.append('rejoin_date', rejoinDate);
    formData.append('reason', reason);
    formData.append('emp_id', empID);
    formData.append('leave_id', leaveHistoryViewData?.id);
    await leavesService
      .applyRejoinForm(formData)
      .then((response: any) => {
        toast.success(trans('Leave Rejoin Applied Successfully'));
        closeModal();
      })
      .catch((error: any) => {
        console.log('error from rejoin form', error);
      });
  };

  const handleRejoinDate = (value: any) => {
    setRejoinDate(value);
  };
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="60vh"
      modalWidth="470px"
      height="90vh"
      overflowY={'auto'}
    >
      <ModalHeader
        modal={{ modal_title: trans('Leave Details') }}
        closeModal={closeModal}
      />
      <Grid container spacing={2} style={{ padding: '10px' }}>
        <Grid
          item
          xs={12}
          className="left-grid_history"
          style={{ marginLeft: '10px' }}
        >
          <Grid container style={{ padding: '10px' }}>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {trans('Leave Details')}
              </Typography>
            </Grid>

            <CardContentTile
              tile_key={trans('Leave Type')}
              tile_value={leaveHistoryViewData.leave_type.name}
            />
            <CardContentTile
              tile_key={trans('Leave Frequency')}
              tile_value={
                leaveHistoryViewData?.day_freq == 1
                  ? trans('Full Day')
                  : trans('Half Day')
              }
            />
            <CardContentTile
              tile_key={trans('Start Date')}
              tile_value={moment(leaveHistoryViewData?.start_date).format(
                baseDateFormatting,
              )}
            />
            <CardContentTile
              tile_key={trans('End Date')}
              tile_value={moment(leaveHistoryViewData?.end_date).format(
                baseDateFormatting,
              )}
            />
            <CardContentTile
              tile_key={trans('Reason')}
              tile_value={leaveHistoryViewData?.leave_reason}
            />
          </Grid>
          {leaveHistoryViewData?.attachment && (
            <Grid container style={{ padding: '10px' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Attachments')}
                </Typography>
              </Grid>
              <Box style={{ marginTop: '35px' }} />
              <DropAndSelect
                src={
                  leaveHistoryViewData?.attachment
                    ? leaveHistoryViewData?.attachment
                    : ''
                }
                disabledDeleteBtn={true}
                isAttachmentSigned={true}
              />
            </Grid>
          )}
        </Grid>

        <Grid item xs={12}>
          <DatePickerInput
            width="100%"
            label={trans('Rejoining Date')}
            value={rejoinDate}
            supportUTC={false}
            onChange={(newValue: any) => {
              const formattedDate = moment(newValue).format(
                defaultDateFormatting,
              );
              handleRejoinDate(formattedDate);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            type="string"
            label={trans('Remarks')}
            placeholder={trans('Write Reason')}
            value={reason}
            onChange={(e: any) => setReason(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <ModalFooter
            isSubmitting={disable}
            onClickSubmit={() => handleSubmit()}
            onClickCancel={() => {
              closeModal();
            }}
          />
        </Grid>
      </Grid>

      {/* </Compdirection> */}
      {/* <Box style={{ marginTop: '3px' }} /> */}
    </CustomModal>
  );
};
export default LeaveRejoinform;
